export default __webpack_public_path__ + "static/media/carrio.c993a5da.png";